import { render } from "./megaSpinner.vue?vue&type=template&id=1b171a86&scoped=true&ts=true"
import script from "./megaSpinner.vue?vue&type=script&lang=ts"
export * from "./megaSpinner.vue?vue&type=script&lang=ts"

import "./megaSpinner.vue?vue&type=style&index=0&id=1b171a86&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b171a86"]])

export default __exports__